import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgHydration = function SvgHydration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    d: "M20.595 16.727a.75.75 0 1 1 1.5 0c0 1.158-.907 2.154-2.095 2.154a.75.75 0 0 1 0-1.5c.298 0 .595-.262.595-.654Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20.505 8.393A1.045 1.045 0 0 0 20 8.25c-.231 0-.416.094-.504.143-.108.06-.212.136-.306.213a5.76 5.76 0 0 0-.614.602 14.208 14.208 0 0 0-1.426 1.932c-.955 1.535-1.898 3.617-1.9 5.614-.023 1.76.862 3.413 2.342 4.316a4.603 4.603 0 0 0 4.816 0c1.48-.903 2.365-2.556 2.341-4.317-.001-1.996-.943-4.078-1.898-5.613a14.223 14.223 0 0 0-1.427-1.932 5.76 5.76 0 0 0-.613-.602 2.141 2.141 0 0 0-.306-.213Zm1.072 3.54c.901 1.448 1.672 3.243 1.672 4.826v.01c.018 1.254-.611 2.404-1.622 3.02a3.103 3.103 0 0 1-3.254 0c-1.01-.616-1.64-1.766-1.623-3.02v-.01c0-1.583.772-3.378 1.673-4.826.444-.713.9-1.312 1.27-1.723.116-.13.22-.237.307-.32.088.083.191.19.308.32.37.411.826 1.01 1.27 1.723Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M9.009 20.38A1.947 1.947 0 0 1 9 20.212c0-.911.626-2.193 3.578-3.16a.75.75 0 0 1 .953.426c.15.37-.06.77-.447.912-1.908.626-2.593 1.366-2.593 1.822 0 1.139 3.696 2.79 9.509 2.79 5.812 0 9.509-1.651 9.509-2.79 0-.456-.686-1.196-2.594-1.822-.387-.143-.596-.542-.447-.912a.75.75 0 0 1 .954-.427c2.951.997 3.577 2.278 3.577 3.161 0 .062-.003.123-.008.183a.707.707 0 0 1 .007.1c0 5.808-4.919 10.507-11 10.507C13.95 31.001 9 26.302 9 20.493c0-.038.003-.076.009-.112Zm1.73 2.18c2.086 1.222 5.745 1.866 9.262 1.866 3.513 0 7.168-.63 9.255-1.848-.988 4.009-4.761 7-9.257 7-4.502 0-8.28-3-9.26-7.017Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20ZM20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5Z",
    clipRule: "evenodd"
  })));
};

export { SvgHydration as default };
//# sourceMappingURL=hydration.svg.js.map
